import { debounce } from 'throttle-debounce';
import saveTheme from "fantastic/actions/saveTheme";

const saveThemeDirectly = (dispatch, getState) => {
  dispatch(saveTheme());
};

const debouncedSaveThemeFn = debounce(2000, saveThemeDirectly);

export default (dispatch, getState) => {
  debouncedSaveThemeFn(dispatch, getState);
};
